import { aboutContent } from "../content/content.js";

function About() {
  return (
    <>
      {/*<div style={{ marginTop: "30rem", width: "100%", height: "20px" }} className="about-scroll"></div>*/}
      <h2 className="main-title about-h2" style={{ textAlign: "center" }}>
        O NAS
      </h2>
      <div className="container about">
        <div className="row">
          <div className="col-md-3 text-center" align="top">
            <img alt="about" src="/img/mp-tech-small-logo-no-bg.png" className="img-fluid" />
          </div>
          <div className="col-md-12">
            <p className="main-p">{aboutContent.mainParagraph1}</p>
            <br />
            <p className="main-p">{aboutContent.mainParagraph2}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
